'use client'

import type { TextValue } from '@/lib/content-standard/rich-text'

export interface TOCItem {
    id: string
    label: string
}

interface TableOfContentsProps {
    items: TOCItem[]
    /** The pills' accessible name. */
    label: TextValue
}

/**
 * Section pills under a page's hero: a static, left-aligned wrapping row of pills at
 * least 95px wide with centred labels, each scrolling to its section.
 */
export function TableOfContents({ items, label }: TableOfContentsProps) {
    if (items.length === 0) {
        return null
    }

    return (
        <nav aria-label={label.text} className="my-[72px] md:my-24">
            <ul className="mx-auto flex max-w-[1056px] flex-wrap gap-x-2 px-4">
                {items.map(({ id, label }) => (
                    <li key={id} className="mb-4 list-none">
                        <a
                            href={`#${id}`}
                            className="inline-block min-w-[95px] rounded-[7px] bg-[#d9f5f9] px-2 py-1 text-center text-base font-normal text-[#5f6368] transition-colors hover:bg-[#8ce2ec] hover:text-[#008a99]"
                            onClick={(e) => {
                                e.preventDefault()
                                document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' })
                                window.history.pushState(null, '', `#${id}`)
                            }}
                        >
                            {label}
                        </a>
                    </li>
                ))}
            </ul>
        </nav>
    )
}
